var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgMakeChangesInvestments = function SvgMakeChangesInvestments(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 7") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDCF1\\u2705-Investments-(I)",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Investment-switch---Accum---Current-investment-switch---D01",
    transform: "translate(-128.000000, -776.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(104.000000, 463.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(24.000000, 313.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFF0E0",
    cx: 20,
    cy: 20,
    r: 20
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(8.000000, 8.000000)",
    fill: "#FF8200"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(2.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1666667,13.3333333 C11.7075,13.3333333 9.66416667,12.8008333 8.33333333,11.9066667 C8.33333333,12.5283333 8.33333333,12.9383333 8.33333333,13.3333333 C8.33333333,14.7141667 10.945,15.8333333 14.1666667,15.8333333 C17.3883333,15.8333333 20,14.7141667 20,13.3333333 C20,12.9383333 20,12.5283333 20,11.9066667 C18.6691667,12.8008333 16.6258333,13.3333333 14.1666667,13.3333333 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1666667,17.5 C11.7075,17.5 9.66416667,16.9675 8.33333333,16.0733333 C8.33333333,16.695 8.33333333,17.105 8.33333333,17.5 C8.33333333,18.8808333 10.945,20 14.1666667,20 C17.3883333,20 20,18.8808333 20,17.5 C20,17.105 20,16.695 20,16.0733333 C18.6691667,16.9675 16.6258333,17.5 14.1666667,17.5 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 14.1666667,
    cy: 9.16666667,
    rx: 5.83333333,
    ry: 2.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 5.83333333,
    cy: 2.5,
    rx: 5.83333333,
    ry: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.66666667,14.9775 C6.39416667,14.9908333 6.1175,15 5.83333333,15 C3.37416667,15 1.33083333,14.4675 -3.0331293e-13,13.5733333 C-3.0331293e-13,14.195 -3.0331293e-13,14.605 -3.0331293e-13,15 C-3.0331293e-13,16.3808333 2.61166667,17.5 5.83333333,17.5 C6.11666667,17.5 6.39416667,17.4883333 6.66666667,17.4716667 L6.66666667,14.9775 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.66666667,10.8108333 C6.39416667,10.8241667 6.1175,10.8333333 5.83333333,10.8333333 C3.37416667,10.8333333 1.33083333,10.3008333 -3.0331293e-13,9.40666667 C-3.0331293e-13,10.0283333 -3.0331293e-13,10.4383333 -3.0331293e-13,10.8333333 C-3.0331293e-13,12.2141667 2.61166667,13.3333333 5.83333333,13.3333333 C6.11666667,13.3333333 6.39416667,13.3216667 6.66666667,13.305 L6.66666667,10.8108333 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.26666667,6.47166667 C7.515,6.59666667 6.70166667,6.66666667 5.83333333,6.66666667 C3.37416667,6.66666667 1.33083333,6.13416667 -1.21680443e-13,5.24 C-1.21680443e-13,5.86166667 -1.21680443e-13,6.27166667 -1.21680443e-13,6.66666667 C-1.21680443e-13,8.0475 2.61166667,9.16666667 5.83333333,9.16666667 C6.1175,9.16666667 6.395,9.155 6.66916667,9.13833333 C6.67916667,8.08583333 7.25833333,7.17166667 8.26666667,6.47166667 Z",
    id: "Path"
  })))))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMakeChangesInvestments);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/make-changes-investments.5c3e45f0f30686a2895f49df15dee3d7.svg";